// copypaste from desktop header

export default (theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    alignItems: 'center',
    marginBottom: 16,
    '@media (max-width: 1050px)': {
      flexWrap: 'wrap',
      '& > *': {
        marginBottom: 16,
      },
    },
  },
  subtitle: {
    color: theme.palette.textColor.secondary,
    fontSize: '0.75rem',
    display: 'block',
    textTransform: 'capitalize',
  },
  selector: {
    margin: 0,

    '& .MuiSelect-root': {
      color: '#777',
      fontWeight: 500,
      fontSize: 14,
      width: 60,
      padding: '10px 16px',
    },
    '& .MuiSelect-icon': {
      right: 4,
    },
  },
  selectorWide: {
    '& .MuiSelect-root': {
      width: 80,
    },
  },
  group: {
    display: 'flex',
    gap: 16,
  },
  publishGroup: {
    display: 'flex',
    gap: 16,
    minWidth: 210,
  },
  iconButtonGroup: {
    display: 'flex',
    gap: 8,
  },
  searchGroup: {
    display: 'flex',
    gap: 16,
    flexGrow: 1,
  },
  // BUTTONS
  iconButton: {
    padding: 8,
    color: theme.palette.textColor.secondary,
    background: theme.palette.background.default,
    textTransform: 'capitalize',
    '&:hover': {
      color: theme.palette.textColor.primary,
      background: 'rgba(0, 0, 0, 0.05)'
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
      background: 'rgba(0, 0, 0, 0.05)'
    },
    '@media (max-width: 280px)': {
      width: '40px',
    },
    '& .MuiButton-endIcon': {
      color: '#777',
      margin: 0,
    }
  },
  addButton: {
    '& .MuiPaper-root': {
      marginTop: 32,
    },
    '& .MuiMenu-list': {
      padding: '4px 0'
    }
  },
  addOption: {
    color: theme.palette.textColor.primary,
    fontSize: 14,
    fontWeight: 400,
  },
  // MANAGE BUTTONS
  disabledReconcile: {
    pointerEvents: 'none',
  },
  red: {
    color: theme.palette.textColor.red,
    borderColor: theme.palette.borderColor.white,
    background: theme.palette.background.lightRed,
    '&:hover': {
      color: `${theme.palette.textColor.red} !important`,
      borderColor: theme.palette.borderColor.red,
      background: theme.palette.background.lightRed,
    },
    '&:focus': {
      color: `${theme.palette.textColor.red} !important`,
      borderColor: theme.palette.borderColor.red,
      background: theme.palette.background.lightRed,
    },
    '&.Mui-disabled': {
      borderColor: theme.palette.borderColor.primary,
    },
  },
  reconcileBtn: {
    color: `${theme.palette.textColor.white} !important`,
    borderColor: `${theme.palette.borderColor.white} !important`,
    background: `${theme.palette.background.green} !important`,
    '&:hover': {
      color: `${theme.palette.textColor.white} !important`,
      borderColor: `${theme.palette.borderColor.white} !important`,
      background: `${theme.palette.background.green} !important`,
    },
    '&:focus': {
      color: `${theme.palette.textColor.white} !important`,
      borderColor: `${theme.palette.borderColor.white} !important`,
      background: `${theme.palette.background.green} !important`,
    },
  },
  // FILTER BUTTON
  popperContainer: {
    zIndex: 100,
  },
  paper: {
    width: 85,
    padding: 8,
    borderRadius: 0,
    borderColor: theme.palette.borderColor.lightGrey,
  },
  options: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.textColor.secondary,
    padding: '0 10px',
    margin: '10px 0',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.textColor.primary,
    },
  },
  activeOption: {
    color: theme.palette.textColor.primary,
  },
  // DATE TYPE SELECTOR
  dateSelector: {
    margin: 0,

    '& .MuiSelect-root': {
      color: '#777',
      fontWeight: 500,
      fontSize: 14,
      width: 60,
      padding: 10,
    },
    '& .MuiSelect-icon': {
      right: 4,
    },
  },
  monthPicker: {
    display: 'flex',
    alignItems: 'center',
  }
});
